var _ellipse, _rect, _path, _ellipse2, _rect2, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSocial(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.4146,
    cy: 11.5775,
    rx: 4.08449,
    ry: 4.07754,
    fill: "#5AA0FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26.418,
    y: 16.6899,
    width: 7.65842,
    height: 16.3102,
    rx: 1.4905,
    fill: "#5AA0FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4507 16.9362C29.5739 16.1511 31.1207 16.4238 31.9077 17.5458L31.9831 17.6534C32.7719 18.7779 32.4983 20.329 31.3726 21.1159L24.1526 26.1629C23.0294 26.948 21.4825 26.6753 20.6956 25.5533L20.6201 25.4457C19.8314 24.3212 20.1049 22.7701 21.2306 21.9832L28.4507 16.9362Z",
    fill: "#BDD9FF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.08449,
    cy: 4.07754,
    rx: 4.08449,
    ry: 4.07754,
    transform: "matrix(-1 0 0 1 13.6699 7.5)",
    fill: "#37DC8C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 7.65842,
    height: 16.3102,
    rx: 1.4905,
    transform: "matrix(-1 0 0 1 13.582 16.6899)",
    fill: "#37DC8C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5493 16.9362C10.4261 16.1511 8.87928 16.4238 8.09235 17.5458L8.01687 17.6534C7.22815 18.7779 7.50165 20.329 8.6274 21.1159L15.8474 26.1629C16.9706 26.948 18.5175 26.6753 19.3044 25.5533L19.3799 25.4457C20.1686 24.3212 19.8951 22.7701 18.7694 21.9832L11.5493 16.9362Z",
    fill: "#AFF1D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSocial);
export default __webpack_public_path__ + "static/media/ic_social.36120c82103b9a6b84fde4b825f88a5b.svg";
export { ForwardRef as ReactComponent };